export default "__VITE_ASSET__CSSQFWbk__"